import * as React from 'react';

import { Bem } from '../../../../service/Bem/Bem';

import './SelectorItem.css';

export interface SelectorItemProps {
    id: string;
    name: string;
    isActive: boolean;
    isDisabled: boolean;
}

const BLOCK = 'selector-item';

export class SelectorItem extends React.PureComponent<SelectorItemProps> {
    render() {
        const { id, name, isActive, isDisabled } = this.props;

        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    mods: {
                        active: isActive,
                        disabled: isDisabled
                    }
                })}
            >
                <div className={Bem.cls(BLOCK, 'name')}>{name}</div>
                <div className={Bem.cls(BLOCK, 'id')}>№ {id}</div>
            </div>
        );
    }
}
